export const dashboardCardsData =  [
    { head: "# of Orders", value: 1000 },
    { head: "# of PO", value: 1100 },
    { head: "# of Returns", value: 10 },
    { head: "Total Inventory", value: "2 Lacs "},
    { head: "Total Sutable Inventory", value: "2 Lacs " },
    { head: "Throughput", value: 10 },
    { head: "Fill Rate", value: 10 },
    { head: "Order Pending to be Picked", value: 100 },
    { head: "Order Pending to be Picked", value: 900 },
    
  
    
  ];
  